import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import './LegalPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

// last_updated_at is a "YYYY-MM-DD HH:MM:SS" DB timestamp - take the date part
// literally (no Date() timezone parsing) so the displayed day never shifts
// depending on the viewer's or server's timezone.
const formatLastUpdated = (value) => {
  const match = (value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const TermsOfService = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/landing_page_api.php/pages/terms_of_service`);
      if (response.data.status === 'success') {
        setPageData(response.data.data);
      }
    } catch (error) {
      console.error('Failed to load page content:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderSection = (section) => {
    return (
      <section key={section.id} className="legal-section">
        <h2>{section.section_title}</h2>
        <div dangerouslySetInnerHTML={{ __html: section.section_content }} />
      </section>
    );
  };

  if (loading) {
    return (
      <div className="legal-page">
        <Header />
        <div className="loading-container" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="legal-page">
      <Header />

      <div className="legal-hero">
        <div className="container">
          <h1>{pageData?.page_title || 'Terms of Service'}</h1>
          <p>Last updated: {formatLastUpdated(pageData?.last_updated_at)}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="container">
          {pageData?.sections && pageData.sections.length > 0 ? (
            pageData.sections.map(renderSection)
          ) : (
            <>
              <section className="legal-section">
                <h2>Agreement to Terms</h2>
                <p>
                  By accessing or using eHaazri's attendance management platform ("Service"), you agree to be
                  bound by these Terms of Service ("Terms"). If you disagree with any part of these terms,
                  you may not access the Service.
                </p>
              </section>

              <section className="legal-section">
                <h2>Description of Service</h2>
                <p>
                  eHaazri provides a cloud-based attendance management platform that includes:
                </p>
                <ul>
                  <li>Biometric facial recognition for attendance verification</li>
                  <li>Geofencing and GPS-based location tracking</li>
                  <li>Real-time attendance monitoring and reporting</li>
                  <li>Leave management and shift scheduling</li>
                  <li>Multi-device support (web and mobile applications)</li>
                  <li>Administrative dashboard and analytics</li>
                </ul>
              </section>

              <section className="legal-section">
                <h2>Contact Information</h2>
                <p>
                  If you have any questions about these Terms, please contact us:
                </p>
                <ul>
                  <li>Email: legal@ehaazri.com</li>
                  <li>Website: Use our Contact Support form</li>
                </ul>
              </section>
            </>
          )}
        </div>
      </div>

      <Footer />
      <FloatingHelpButton />
      <ChatWidget />
    </div>
  );
};

export default TermsOfService;
